import { Product } from '@la/types';
import { OptionalAddOnCard } from '../AddOnCard/OptionalAddOnCard';
import { RequiredAddOnCard } from '../AddOnCard/RequiredAddOnCard';
import styles from './RegistrationAddOnsCard.module.scss';

/*
*** About Add-On Cards ***
* Add-On Cards are used to display information about add-on products during the
registration process. It has three variants, "optional", "required", and
"truncated", which all display the same general information, but with different styles.
* The appearance and behavior of the card is controlled by the `cardDisplayType`
prop which in turn controls the styles.
* Since the layout of this component is handled using CSS-Grid, the different
components may not be rendered in the order in which they are added in the JSX
and in some cases different child components or elements may not render at all
or may have their visibility toggled by user interactions.
* In every case if an add-on's description is longer than 20 words, the description
will be truncated to 14 words and a "View more" button will be displayed.
* If a card's display type is "truncated," the user will not display any of the
selection elements for the add-on.
* If a card's display type is "required," all selection elements except Quantity
will be displayed.
* If a card's display type is "optional," all selection elements will be displayed.
*/

export default function AddOnCards({
  optionalAddOns,
  requiredAddOns,
}: Readonly<{
  optionalAddOns: Product[];
  requiredAddOns: Product[];
}>) {
  return (
    <>
      {requiredAddOns.length > 0 ? (
        <div className={styles.addOnsSection}>
          <div className={styles.addOnsSectionTitle}>
            Included in registration
          </div>
          {requiredAddOns.map((addon) => (
            <RequiredAddOnCard
              key={addon.id}
              addOnData={addon}
              cardDisplayType="required"
            />
          ))}
        </div>
      ) : null}
      {optionalAddOns.length > 0 ? (
        <div className={styles.addOnsSection}>
          <div className={styles.addOnsSectionTitle}>Optional add-ons</div>
          {optionalAddOns.map((addon) => (
            <OptionalAddOnCard
              key={addon.id}
              addOnData={addon}
              cardDisplayType="optional"
            />
          ))}
        </div>
      ) : null}
    </>
  );
}
